<template>

  <el-main>

    <el-form :model="navigation" status-icon ref="navigation" label-width="200px">
      <el-form-item label="网址导航在新窗口打开">
          <span slot="label">
            <el-tooltip>
              <span slot="content">网址导航默认在新窗口打开，推荐您关闭此开关并设置新建窗口时默认打开本站<br/>Chrome浏览器可以通过安装New Tab Redirect拓展设置在新窗口默认打开本站</span>
              <i class='el-icon-question'></i>
            </el-tooltip>
            网址导航在新窗口打开
          </span>
        <el-switch v-model="navigation.link_target" active-value="_blank" inactive-value="_self" @change="save"></el-switch>
      </el-form-item>
      <el-form-item label="网址导航提示网址名称">
          <span slot="label">
            <el-tooltip>
              <span slot="content">网址导航因为数目较多，默认开启显示导航名称（鼠标悬浮2s后显示）<br/>但如果您对您的导航列表已经熟悉可以关闭此开关</span>
              <i class='el-icon-question'></i>
            </el-tooltip>
            网址导航提示网址名称
          </span>
        <el-switch v-model="navigation.name_tip" @change="save"></el-switch>
      </el-form-item>
    </el-form>

  </el-main>

</template>

<script>
export default {
  name: 'Setting',
  data () {
    return {
      navigation: {
        link_target: '_blank',
        name_tip: true
      }
    }
  },
  created: function () {
    document.title = '网湖 - 导航设置 - 网址导航|网站导航|网址大全|网站大全'
    this.$http.defaults.baseURL = process.env.VUE_APP_BASE_API
    this.getSetting()
  },
  methods: {
    getSetting () {
      let navigationList = localStorage.getItem('navigationList')
      if (navigationList == null) {
        return
      }
      navigationList = JSON.parse(navigationList)
      let keys = Object.keys(navigationList)
      if (keys.indexOf('link_target') >= 0) {
        this.navigation.link_target = navigationList.link_target
      }
      if (keys.indexOf('name_tip') >= 0) {
        this.navigation.name_tip = navigationList.name_tip
      }
    },
    save () {
      this.$http.post('navigation/config', this.navigation, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code === 0) {
          localStorage.removeItem('navigationList')
          this.$message({message: '保存成功', type: 'success'})
        } else if (response.data.code === 80003) {
          localStorage.clear()
          this.$router.push('/')
        } else {
          this.$message({message: response.data.msg, type: 'error'})
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-main {
  margin-left: 10%;
  width: 80%;
  min-height: 85vh;
}

</style>



// WEBPACK FOOTER //
// src/components/Setting.vue